// Defining functions to use
let allPaginations = []
const initZoom = (images, imagesSrcArray) => {
  images.forEach((image, index) => {
    // If the images are from product.media, they don't have a data-zoom-id yet to get the targetIndex
    const targetIndex = index;
    image.dataset.zoomId = targetIndex;
    const img = image.tagName === "IMG" ? image : image.querySelector('img'); // Images from raffles are under pictures, so the actual img we want is nested inside
    
    const handleZoomImageClick = node => {
      node && node.classList.remove('images-loading');
      openZoomContainer();
      scrollZoom(targetIndex);
    }
    
    img.addEventListener('click', () => {
      handleZoomImagesInit(imagesSrcArray);
      allPaginations = document.querySelectorAll('.zoom__pagination')
      const zoomImagesNodeList = document.querySelectorAll('.zoom__image');
      const zoomImages = Array.from(zoomImagesNodeList);
      const parentNode = img.parentNode

      if (zoomImages.every(img => img.complete)) {
        handleZoomImageClick();
      } else {
        let loadedCount = 0;
        parentNode.classList.add('images-loading')

        const handleFirstScroll = () => {
          loadedCount ++;
          if (loadedCount === imagesSrcArray.length) {
            handleZoomImageClick(parentNode);
          }
        }

        zoomImagesNodeList.forEach(image => {
          image.addEventListener('load', handleFirstScroll);
        })
      }
      
    })
  })
  
  zoomCloseButton && zoomCloseButton.addEventListener('click', () => {
    closeZoomContainer(zoomContainer);
  });
}

const scrollZoom = (targetIndex) => {
  const target = document.querySelector(`.zoom__image[data-zoom-id='${targetIndex}']`);
  const targetLeft = target.offsetLeft;
  zoomImagesContainer.scrollTo({
    left: targetLeft,
    behavior: 'smooth'
  })
}

const openZoomContainer = () => {
  // document.body.style.overflow = "hidden"; // Prevent body scrolling
  lockBody(zoomContainer)
  zoomContainer.classList.add('active');
  document.addEventListener("keyup", handleEscKey);
  document.addEventListener('keyup', handleArrowNavigation)
}

const closeZoomContainer = () => {
  // document.body.style.overflowY = ""; // Re-enable body scrolling
  unlockBody(zoomContainer)
  zoomContainer.classList.remove('active');
  document.removeEventListener("keyup", handleEscKey);
  document.removeEventListener('keyup', handleArrowNavigation)
}

const handleEscKey = e => e.key === "Escape" && closeZoomContainer();

const togglePaginationActive = (targetIndex) => {
  const targetPagination = document.querySelector(`.zoom__pagination[data-zoom-id='${targetIndex}']`);
  allPaginations.forEach(bullet => {
    bullet.classList.remove('active');
  })
  targetPagination.classList.add('active');
}

const handleScroll = () => {
  const wrapperLeft = -zoomImagesWrapper.getBoundingClientRect().left;
  const targetIndex = Math.abs(Math.round(wrapperLeft / window.innerWidth)); // Sometimes we get -0 index, change it to 0 with Math.abs
  togglePaginationActive(targetIndex);
}

const handleArrowNavigation = e => {
  e.key === "ArrowRight" ? handleNextClick() 
  : e.key === "ArrowLeft" ? handlePrevClick() 
  : null
}

const handleNextClick = () => {
  // get current index by checking active pagination's data-zoom-id
  const currentZoomId = document.querySelector('.zoom__pagination.active').dataset.zoomId;
  const currentIndex = parseInt(currentZoomId)
  // get last index
  const lastZoomId = allPaginations[allPaginations.length - 1].dataset.zoomId
  const lastIndex = parseInt(lastZoomId)

  // unless already at last index, scroll right (currentIndex + 1)
  currentIndex !== lastIndex && scrollZoom(currentIndex + 1)
}
const handlePrevClick = () => {
  // get current index by checking active pagination's data-zoom-id
  const currentZoomId = document.querySelector('.zoom__pagination.active').dataset.zoomId;
  const currentIndex = parseInt(currentZoomId)

  // unless already at first index, scroll left (currentIndex - 1)
  currentIndex !== 0 && scrollZoom(currentIndex - 1)
}

const handleZoomImagesInit = imagesSrcArray => {
  if (zoomImagesWrapper.children.length === 0) {
    imagesSrcArray.forEach((src, index) => {
      // Create zoom images and append into container
      const zoomImage = document.createElement('IMG');
      zoomImage.src = src;
      zoomImage.setAttribute("loading", "eager");
      zoomImage.classList.add('zoom__image');
      zoomImage.dataset.zoomId = index;
      zoomImagesWrapper.appendChild(zoomImage);

      // Create zoom paginations and append into container
      const paginationWrapper = document.createElement('DIV');
      const paginationCircle = document.createElement('DIV');
      paginationWrapper.appendChild(paginationCircle);
      paginationWrapper.classList.add('zoom__pagination');
      index === 0 && paginationWrapper.classList.add('active'); // Set first pagination as active
      paginationWrapper.dataset.zoomId = index;
      paginationWrapper.addEventListener('click', () => {
        const targetIndex = paginationWrapper.dataset.zoomId;
        scrollZoom(targetIndex);
      })
      zoomPaginationContainer.appendChild(paginationWrapper);
    })
    
    // Bind event listeners to arrow navigation
    const leftArrow = document.querySelector('.zoom__navigation-arrow--left')
    const rightArrow = document.querySelector('.zoom__navigation-arrow--right')
    leftArrow.addEventListener('click', handlePrevClick)
    rightArrow.addEventListener('click', handleNextClick)

    // Bind swipe left and right listeners
    // Swipe Up / Down / Left / Right
    let initialX = null;
    let initialY = null;

    const startTouch = (e) => {
      initialX = e.touches[0].clientX;
      initialY = e.touches[0].clientY;
    };

    const moveTouch = (e) => {
      e.preventDefault();
      if (initialX === null) {
        return;
      }

      if (initialY === null) {
        return;
      }

      let currentX = e.touches[0].clientX;
      let currentY = e.touches[0].clientY;

      let diffX = initialX - currentX;
      let diffY = initialY - currentY;

      if (Math.abs(diffX) > Math.abs(diffY)) {
        // sliding horizontally
        if (diffX > 0) {
          // swiped left
          handleNextClick()
        } else {
          // swiped right
          handlePrevClick()
        }
      } else {
        // sliding vertically
        if (diffY > 0) {
          // swiped up
        } else {
          // swiped down
        }
      }

      initialX = null;
      initialY = null;
    };

    zoomImagesContainer.addEventListener("touchstart", startTouch, false);
    zoomImagesContainer.addEventListener("touchmove", moveTouch, false);

    zoomImagesContainer.addEventListener("scroll", () => {
      handleScroll();
    }, {passive: true});
  }
}


// Getting dom elements and running functions
const zoomContainer = document.querySelector('.zoom__container');
const zoomImagesContainer = document.querySelector('.zoom__images-container');
const zoomImagesWrapper = document.querySelector('.zoom__images-wrapper');
const zoomPaginationContainer = document.querySelector('.zoom__pagination-container');
const zoomCloseButton = document.querySelector('.zoom__container .icon-close');

const raffleImages = document.querySelectorAll('#raffle__collage-grid .collage__image');
const lookbookImages = document.querySelectorAll('#lookbook__collage-grid .collage__image');
const productImages = document.querySelectorAll('img.product-featured-media'); // Only get the images of the product media for the zoom (videos in zoom is not in scope)

if (raffleImages.length > 0) {
  const raffleImagesArray = Array.from(raffleImages);
  const raffleImagesSrcArray = raffleImagesArray.map(image => image.querySelector('img').src.replace('_30x.', '.'));
  initZoom(raffleImages, raffleImagesSrcArray);
}

if (lookbookImages.length > 0) {
  const lookbookImagesArray = Array.from(lookbookImages);
  const lookbookImagesSrcArray = lookbookImagesArray.map(image => image.querySelector('img').src.replace('_30x.', '.'));
  initZoom(lookbookImages, lookbookImagesSrcArray);
}

if (productImages.length > 0) {
  const productImagesJson = zoomContainer.querySelector('script').innerHTML;
  const productImagesArray = Array.from(JSON.parse(productImagesJson));
  const productImagesSrcArray = productImagesArray.map(src => src.replace('//cdn', 'https://cdn'));
  initZoom(productImages, productImagesSrcArray);
}